export default __webpack_public_path__ + "static/media/goods-services1.327844d8.jpg";